import React from 'react';
import { Button, Row, Col } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { withRouter } from 'dva/router';

import styles from './styles.less';

class ExportLeadVisits extends React.Component {
  startExport() {
    const { filter, period, sorting, data, match: { params: { projectId } } } = this.props;

    if (data === 'companies') {
      this.props.dispatch({
        type: 'leads/startExportCompanies',
        payload: {
          filter,
          period,
          sorting,
          projectId,
        },
      });
    }

    if (data === 'visits') {
      this.props.dispatch({
        type: 'leads/startExportVisits',
        payload: {
          filter,
          period,
          sorting,
          projectId,
        },
      });
    }
  }
  download() {
    const { data } = this.props;

    if (data === 'visits') {
      this.props.dispatch({
        type: 'leads/downloadVisits',
        payload: {
          projectId: this.props.match.params.projectId,
          downloadAsAttachment: true,
        },
      });
    }

    if (data === 'companies') {
      this.props.dispatch({
        type: 'leads/downloadCompanies',
        payload: {
          projectId: this.props.match.params.projectId,
          downloadAsAttachment: true,
        },
      });
    }

    setTimeout(() => {
      this.props.dispatch({
        type: 'leads/resetExport',
      });
    }, 1000);
  }
  render() {
    const startTime = this.props.leads.exportStartedTimestamp;
    const endTime = this.props.leads.exportCompletedTimestamp;

    return (
      <Row type="flex" gutter={32} align="middle" className={styles.exportFile}>
        <Col>
          <Button
            className={styles.withIcon}
            size="large"
            type="primary"
            icon={endTime && 'download'}
            loading={startTime && !endTime}
            onClick={endTime ? this.download.bind(this) : this.startExport.bind(this)}
          >
            <i className={`${styles.btnIcon} ${endTime || startTime ? '' : styles.addFileIcon}`} />
            {
              startTime && !endTime ?
                <FormattedMessage id="Common.Exporting" />
                : endTime ?
                  <FormattedMessage id="Common.Download" />
                  : <FormattedMessage id="Common.NewExport" />
            }
          </Button>
        </Col>
      </Row>
    );
  }
}

export default withRouter(connect(({ leads }) => ({ leads }))(injectIntl(ExportLeadVisits)));




// WEBPACK FOOTER //
// ./src/components/ExportFile/ExportFile.js